<template>
  <div class="partners-bottom-swirl">
    <div class="swirl"></div>
  </div>
</template>